import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20high-tech%20industrial%20laser%20cutting%20manufacturing%20facility%20with%20advanced%20precision%20equipment%20and%20bright%20clean%20workspace%20featuring%20white%20walls%20and%20professional%20lighting%20showcasing%20innovation%20in%20automated%20production%20technology&width=1600&height=900&seq=hero-bg-opt-001&orientation=landscape"
          alt="Laser Manufacturing"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-gray-900/60 to-emerald-900/40"></div>

      <div className="relative h-screen flex items-center">
        <div className="w-full px-6 lg:px-12">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-8">
              <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
              <span className="text-emerald-400 text-sm font-medium">
                Official Malta Distributor • REDSAIL Laser
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
              Precision
              <span className="block text-emerald-400">Laser Technology</span>
            </h1>

            <p className="text-xl md:text-2xl text-white/80 mb-10 max-w-2xl leading-relaxed">
              Your trusted partner in Malta for industrial CO2 laser cutting and engraving machines. 
              Serving wood, acrylic, leather, fabric industries and more.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/product/cm1390e"
                className="group px-8 py-4 bg-emerald-500 text-white font-semibold rounded-full hover:bg-emerald-400 transition-all hover:shadow-xl hover:shadow-emerald-500/30 flex items-center justify-center gap-2 whitespace-nowrap"
              >
                Explore Products
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
              <a
                href="#applications"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/20 transition-all flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-xl"></i>
                Watch Demo
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/80 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
